import { useRef, useState } from "react";
import { Upload } from "lucide-react";
import { fetchWithAuth } from "../../api/fetchWithAuth";

export default function OperatingAoiUploadButton({ onUploaded }) {
    const fileInputRef = useRef(null);
    const [uploading, setUploading] = useState(false);

    async function handleFileSelected(e) {
        const file = e.target.files?.[0];
        if (!file) return;

        setUploading(true);

        try {
            const form = new FormData();
            form.append("file", file);

            const res = await fetchWithAuth(
                "/api/v1/platform/operating-aois/import",
                {
                    method: "POST",
                    body: form,
                }
            );

            if (!res.ok) {
                const err = await res.json().catch((e) => { console.error("[ui/src/platform/components/OperatingAoiUploadButton.jsx] res.json() failed (swallowed):", e); return {}; });
                throw new Error(
                    err.error || `Upload failed for ${file.name}`
                );
            }

            const created = await res.json();
            onUploaded?.(created);
        } catch (err) {
            console.error(err);
            alert(err.message);
        } finally {
            setUploading(false);
            e.target.value = ""; // allow re-upload
        }
    }

    return (
        <>
            {/* Hidden file input */}
            <input
                ref={fileInputRef}
                type="file"
                accept=".kmz,.kml,.geojson,.json,.zip"
                className="hidden"
                onChange={handleFileSelected}
            />

            {/* Visible button */}
            <button
                onClick={() => fileInputRef.current?.click()}
                disabled={uploading}
                className="
          flex items-center gap-1.5
          px-2 py-1
          rounded border border-bg-border
          bg-bg hover:bg-bg-soft
          text-xs text-gray-200
          disabled:opacity-50
        "
            >
                <Upload size={14} />
                {uploading ? "Uploading…" : "Upload AOI"}
            </button>
        </>
    );
}